<template>
    <modal :name="name" :scrollable="true" :clickToClose="false" :tooltip="tooltip" height="auto"
        styles="border-radius: 24px; overflow: hidden" :width="wide ? width : '620'" class="topz">
        <!-- Header -->
        <div class="modal-header">
            <span class="modal-title">Methane Calculation Details</span>
            <button class="close-btn" @click="handleCloseModal">&#x2715;</button>
        </div>

        <!-- Field Summary -->
        <div class="field-summary px-6 py-5">
            <div class="d-flex align-center justify-space-between">
                <div>
                    <div class="field-name">{{ fieldData.pasture_name }}</div>
                    <div class="field-meta d-flex align-center mt-4">
                        <span class="grey--text text--darken-1 text-body-2">
                            {{ fieldData.pasture_acreage }} acres
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="table-wrapper px-6 py-4">
            <v-simple-table class="tier-table rounded-lg" dense>
                <template v-slot:default>
                    <thead>
                        <tr class="table-head-row">
                            <th class="text-left tier-col py-3 px-4">
                                <div class="d-flex align-center">
                                    Tier
                                </div>
                            </th>
                            <th class="text-left py-3 px-4">
                                <div class="d-flex align-center">
                                    Year
                                </div>
                            </th>
                            <th class="text-left py-3 px-4">
                                <div class="d-flex align-center">
                                    Status
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in fieldData.ipcc_tier1" :key="'t1-' + index" class="tier-row">
                            <td class="px-4 py-3 font-weight-medium">
                                ipcc_tier1
                            </td>
                            <td class="px-4 py-3 text-body-2 font-weight-medium">
                                {{ item.year }}
                            </td>
                            <td class="px-4 py-3 text-body-2 font-weight-medium">
                                <v-chip
                                    :color="item.status === 'complete' ? 'green' : 'red'"
                                    label
                                >
                                    {{ item.status.toUpperCase() }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr v-for="(item, index) in fieldData.ipcc_tier2" :key="'t2-' + index" class="tier-row">
                            <td class="px-4 py-3 font-weight-medium">
                                ipcc_tier2
                            </td>
                            <td class="px-4 py-3 text-body-2 font-weight-medium">
                                {{ item.year }}
                            </td>
                            <td class="px-4 py-3 text-body-2 font-weight-medium">
                                <v-chip
                                    :color="item.status === 'complete' ? 'green' : 'red'"
                                    label
                                >
                                    {{ item.status.toUpperCase() }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr v-if="!fieldData.ipcc_tier1?.length && !fieldData.ipcc_tier2?.length">
                            <td colspan="3" class="text-center py-8 grey--text">
                                <v-icon color="grey lighten-2" size="32"
                                    class="mb-2 d-block mx-auto">mdi-table-off</v-icon>
                                No tier data available
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button class="btn-cancel" @click="handleCloseModal">Close</button>
        </div>
    </modal>
</template>

<script>
import { capitalize } from 'lodash';

export default {
    props: {
        modalTitle: { type: String },
        fieldData: { type: Object },
    },

    data() {
        return {
            name: "EntericMethaneYearModal",
            title: "Methane Calculation Details",
        }
    },

    methods: {
        show() {
            this.$modal.show(this.name)
        },

        handleCloseModal() {
            this.$modal.hide(this.name)
            this.$emit("close-modal")
        },
    },

    mounted() {
        this.$modal.show(this.name)
    },
}
</script>


<style scoped>
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px 16px 24px;
    border-bottom: 1px solid #e9ecef;
    background: #ffffff;
}

.modal-title {
    font-size: 17px;
    font-weight: 600;
    color: #1a1a1a;
}

.modal-footer {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 24px 22px;
    border-top: 1px solid #e9ecef;
    background: #ffffff;
}

.close-btn {
    background: none;
    border: none;
    font-size: 17px;
    color: #6b7280;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s;
}

.close-btn:hover {
    color: #111827;
}

.field-name {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.tier-table {
    border: 1px solid #eeeeee;
    overflow: hidden;
}

.table-head-row {
    background-color: #c7ccd2;
}

.table-head-row th {
    font-size: 16px !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #000000 !important;
    border-bottom: 1px solid #eeeeee !important;
}

.tier-row {
    transition: background-color 0.1s ease;
}

.tier-row:hover {
    background-color: #f9f9f9 !important;
}

.tier-row td {
    border-bottom: 1px solid #f2f2f2 !important;
}

.btn-cancel {
    flex: 1;
    max-width: 100px;
    height: 40px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    letter-spacing: 0.01em;
    transition: filter 0.15s ease;
}

.btn-cancel {
    background: #c8ccd2;
    color: #3d4451;
}

.btn-cancel:hover {
    filter: brightness(0.93);
}
</style>